const { database } = require("../config/firebase")
const { ref, set, push, serverTimestamp, get } = require("firebase/database")
const { astronomyText, astronomyQuestions } = require("./astronomyQuestions")

const createAstronomyTextForUser = async (userId, userAppId) => {
  try {
    console.log(`[v0] Creating astronomy text for user ${userId}`)
    console.log(`[v0] userAppId: ${userAppId || "not provided"}`)

    const questions = astronomyQuestions.map((q, index) => ({
      id: index + 1,
      question: q.question,
      options: q.options,
      answer: q.options[q.correctAnswer], // Convertir índice a texto de la respuesta
      correctAnswer: q.correctAnswer, // Mantener el índice también por compatibilidad
      explanation: q.explanation,
      type: "MCQ",
      difficulty: "Facil",
    }))

    console.log(`[v0] Using ${questions.length} pre-generated questions`)

    // Crear el texto en Firebase
    const textRef = push(ref(database, `users/${userId}/texts`))
    const newTextKey = textRef.key

    const newText = {
      id: newTextKey,
      userId: userId,
      numberOfQuestions: questions.length,
      text: astronomyText,
      questions: questions,
      questionType: "MCQ",
      difficulty: "Facil",
      format: "open",
      type: "contextBased",
      topic: "",
      levels: "",
      language: "Espanol",
      timestamp: serverTimestamp(),
      isDefault: true, // Marcador para identificar textos por defecto
    }

    // Solo agregar userAppId si existe y no es null/undefined
    if (userAppId) {
      newText.userAppId = userAppId
    }

    await set(textRef, newText)
    console.log(`[v0] Astronomy text created successfully with ID: ${newTextKey}`)

    return { success: true, textId: newTextKey }
  } catch (error) {
    console.error("[v0] Error creating astronomy text:", error)
    return { success: false, error: error.message }
  }
}

const checkIfAstronomyTextExists = async (userId) => {
  try {
    const textsRef = ref(database, `users/${userId}/texts`)
    const snapshot = await get(textsRef)

    if (snapshot.exists()) {
      const texts = snapshot.val()
      // Buscar si ya existe un texto de astronomía por defecto
      const hasAstronomyText = Object.values(texts).some((text) => text.isDefault === true)
      return hasAstronomyText
    }

    return false
  } catch (error) {
    console.error("[v0] Error checking astronomy text:", error)
    return false
  }
}

module.exports = {
  createAstronomyTextForUser,
  checkIfAstronomyTextExists,
}
